// @flow

import * as React from 'react';
import {renderers} from '@markdoc/markdoc';

import * as components from 'docs/components';

import type {RenderNodes} from '@markdoc/markdoc';

export function renderMarkdocAsReact(content: RenderNodes): React.Node {
  return renderers.react(content, React, {components});
}
